import { QuoteGateway } from './quote-gateway.interface';

export const initQuoteAPI = (apiSlice: any, gateway: QuoteGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Quote'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getQuote: builder.query({
          query: gateway.postQuote,
        }),
        patchQuote: builder.mutation({
          query: gateway.patchQuote,
        }),
        deleteQuote: builder.mutation({
          query: gateway.deleteQuote,
        }),
      }),
      overrideExisting: false,
    });
};

export interface QuoteSliceType {
  useGetQuoteQuery: Function;
  usePatchQuoteMutation: Function;
  useDeleteQuoteMutation: Function;
}
